import { useContext } from "react";
import NoPermission from "../components/ui/NoPermission";
import { AuthContext } from "../contexts/authContext";
import AdminLayout from "./AdminLayout";
import LecturerLayout from "./LecturerLayout";

const AdminOrLecturerLayout = () => {
  const { user } = useContext(AuthContext);

  if (!user || (!user.is_admin && user.user_type !== "lecturer")) {
    return <NoPermission />;
  }

  if (user.is_admin){
    return <AdminLayout />;
  }

  return (
    <LecturerLayout/>
  )
};

export default AdminOrLecturerLayout;
